import request, { PUT } from '../../utils/request';

export default body => request('/config/default-ala-level', { method: PUT, body, headers: { 'Content-Type': 'application/json' } });
